/** Value-indication response fields carrying per-method detail blocks. */
const INDICATION_DETAIL_FIELDS = [
    "comparative_price_details",
    "comparative_value_details",
    "energy_value_details",
    "income_value_details",
    "real_asset_value_details",
] as const;

/** Strip the per-method `*_details` fields from an indication response, leaving the plain indication output. */
export function stripIndicationDetailFields<T extends Record<string, unknown>>(
    indicationData: T,
): Omit<T, (typeof INDICATION_DETAIL_FIELDS)[number]> {
    const result = {...indicationData};
    for (const field of INDICATION_DETAIL_FIELDS) {
        delete result[field];
    }
    return result;
}

export type AppraisalMethodEndpoint = "COMPARATIVE_VALUE" | "INCOME_VALUE" | "REAL_ASSET_VALUE";

const APPRAISAL_METHOD: Record<number, AppraisalMethodEndpoint> = {
    1: "COMPARATIVE_VALUE",
    3: "INCOME_VALUE",
    4: "REAL_ASSET_VALUE",
};

/**
 * The method the market value follows, per the appraisal code (`indication_appraisal`) — not per
 * `indication_leading`, which is only the segment's default method (#19483). The Niederstwert codes 5x
 * carry the method in the ones digit.
 */
export function getAppraisalMethod(appraisal: number | null | undefined): AppraisalMethodEndpoint | undefined {
    if (appraisal == null) return undefined;
    return APPRAISAL_METHOD[appraisal >= 50 ? appraisal % 10 : Math.floor(appraisal / 10)];
}
